import { render } from "./WidegtDeletePopup.vue?vue&type=template&id=335e303c&scoped=true"
import script from "./WidegtDeletePopup.vue?vue&type=script&lang=js"
export * from "./WidegtDeletePopup.vue?vue&type=script&lang=js"

import "./WidegtDeletePopup.vue?vue&type=style&index=0&id=335e303c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335e303c"],['__file',"src/containers/dashboard/WidegtDeletePopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "335e303c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('335e303c', __exports__)) {
    api.reload('335e303c', __exports__)
  }
  
  module.hot.accept("./WidegtDeletePopup.vue?vue&type=template&id=335e303c&scoped=true", () => {
    api.rerender('335e303c', render)
  })

}


export default __exports__